module.exports = __webpack_public_path__ + "static/image 111-319285c8df669431d47185804f354de6.jpg";